import axios from "axios";
import { useQuery } from "react-query";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const fetchCurrency = async () => {
	try {
		const response = await axios.get(`${API_MAP.fetchCurrency}`);
		const { hasError } = response.data;
		if (hasError) {
			console.log("Get currency data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const chooseCurrency = async (credentials) => {
	try {
		const response = await axios.put(
			`${API_MAP.chooseCurrency}`,
			credentials
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log("Set user currency data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const addWeddingPartner = async (credentials) => {
	const response = await axios.put(`${API_MAP.addPartner}`, credentials);
	return response;
};

export const addWeddingPlanner = async (credentials) => {
	const response = await axios.put(`${API_MAP.addPlanner}`, credentials);
	return response;
};

export const fetchAllWallets = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewAllWallets}`);
		const { hasError } = response.data;
		if (hasError) {
			// return errorHandler(response.data.errors);
		} else {
			return response.data?.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const fetchWallet = async ({ currency }) => {
	const response = await axios.get(
		`${API_MAP.viewWallet}?currencyCode=${currency || "NGN"}`
	);
	return response.data;
};

export const useFetchWallet = ({ currency }) => {
	return useQuery(["wallet", { currency }], () =>
		fetchWallet({
			currency,
		})
	);
};

export const fetchBanks = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewBanks}`);
		const { hasError } = response.data;
		if (hasError) {
			return errorHandler(response.data.errors);
		} else {
			return response.data?.data;
		}
	} catch (error) {
		// return errorHandler(error);
	}
};

export const updateBankDetails = async (credentials) => {
	const response = await axios.put(
		`${API_MAP.updateBankDetails}`,
		credentials
	);
	return response;
};
export const updateBvn = async (credentials) => {
	const response = await axios.put(`${API_MAP.updateBvn}`, credentials);
	return response;
};

export const fetchTransactionHistory = async ({
	start,
	end,
	type,
	currencyCode,
}) => {
	// console.log("start", start, "end", end, "type", type, currencyCode);
	const response = await axios.get(
		`${API_MAP.transactionHistory}?start=${start}&end=${end}&type=${type}&currencyCode=${currencyCode}`
	);
	return response.data;
};

export const fetchWalletStat = async ({
	start,
	end,
	frequency,
	currencyCode,
	transaction_type,
}) => {
	try {
		const response = await axios.get(
			`${API_MAP.walletStat}?frequency=${frequency}&start=${start}&end=${end}&currencyCode=${currencyCode}&transaction_type=${transaction_type}`
		);
		const { hasError } = response.data;
		if (hasError) {
			return errorHandler(response.data.errors);
		} else {
			return response.data?.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const fetchWithdrawable = async ({ currencyCode }) => {
	try {
		const response = await axios.get(
			`${API_MAP.withdrawableAmount}?currencyCode=${currencyCode}`
		);
		const { hasError } = response.data;
		if (hasError) {
			return errorHandler(response.data.errors);
		} else {
			return response.data?.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const withdrawFunds = async (credentials) => {
	const response = await axios.post(`${API_MAP.withdrawFunds}`, credentials);
	return response;
};

export const initializeTransaction = async (credentials) => {
	const response = await axios.post(
		`${API_MAP.initializeTransaction}`,
		credentials
	);
	return response;
};

export const fundWallet = async (credentials) => {
	const response = await axios.post(`${API_MAP.fundWallet}`, credentials);
	return response;
};

export const addUserKyc = async (credentials) => {
	const response = await axios.post(`${API_MAP.addUserKyc}`, credentials);
	return response;
};
